import { createSelector } from '@reduxjs/toolkit';
import { ReduxState } from 'services/types';

export const orders = (state: ReduxState) => state.orders;

export const ordersData = createSelector(orders, (orders) =>
	orders.kind === 'FETCHED' ? orders.data : [],
);

export const ordersLoading = createSelector(orders, (orders) => orders.kind === 'LOADING');

export const ordersError = createSelector(orders, (orders) =>
	orders.kind === 'ERROR' ? orders.error : null,
);
